<ui-card>
    <app-segment-header title="time-off-v3.policyComponents.workSchedules.overallSettings.header">
        <div class="buttons">
            <ui-button type="link" [routerLink]="['../overall-settings']"> {{ 'edit' | translate }} </ui-button>
        </div>
    </app-segment-header>

    <div class="field-container">
        <div class="label">
            {{ 'time-off-v3.policyComponents.workSchedules.overallSettings.workScheduleName' | translate }}:
        </div>
        <div [attr.data-cy]="'work-schedule-name'" class="value">{{ workSchedule.name }}</div>
    </div>
    <div class="field-container">
        <div class="label">{{ 'time-off-v3.policyComponents.workSchedules.overallSettings.weekend' | translate }}:</div>
        <div class="value">
            <mat-chip-listbox>
                <ng-container *ngFor="let day of days">
                    <mat-chip *ngIf="workSchedule.weekendDays.includes(day.value)">
                        {{ day.translationString | translate }}</mat-chip
                    >
                </ng-container>
            </mat-chip-listbox>
        </div>
    </div>
</ui-card>
